<template>
  <v-dialog :value="value" max-width="480px" persistent @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="secondary white--text py-3 px-5">
        <span class="text-subtitle-1 font-weight-bold">Change Invoice Details</span>
        <v-spacer />
        <v-btn icon color="white" small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-5 pb-2 px-5">
        <v-text-field
          v-model="form.invoice_date"
          label="Invoice Date"
          outlined
          dense
          hide-details="auto"
          type="date"
          class="mb-4"
        />
        <v-text-field
          v-model="form.remarks"
          label="Remarks"
          outlined
          dense
          hide-details="auto"
          class="mb-4"
        />
        <v-text-field
          v-if="invoiceData.customer_invoice_type !== 'General' && invoiceData.customer_invoice_type !== 'Line Wise'"
          v-model="form.po_no"
          label="PO Number"
          outlined
          dense
          hide-details="auto"
          class="mb-4"
        />
        <v-text-field
          v-if="invoiceData.customer_invoice_type !== 'Line Wise'"
          v-model="form.boe"
          label="BOE Number"
          outlined
          dense
          hide-details="auto"
          class="mb-4"
        />
      </v-card-text>

      <v-card-actions class="px-5 pb-4 pt-2">
        <v-spacer />
        <v-btn depressed outlined @click="close" class="mr-2">Cancel</v-btn>
        <v-btn color="primary" depressed :loading="loading" @click="submit">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ChangeInvoiceDetailsDialog",
  props: {
    value: { type: Boolean, default: false },
    invoiceData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loading: false,
      form: { invoice_date: "", remarks: "", po_no: "", boe: "" },
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.form = {
          invoice_date: this.invoiceData.invoice_date
            ? this.invoiceData.invoice_date.slice(0, 10)
            : "",
          remarks: this.invoiceData.remarks || "",
          po_no: this.invoiceData.po_no || "",
          boe: this.invoiceData.boe || "",
        };
      }
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    submit() {
      this.loading = true;
      this.$api.customerInvoice
        .updateInvoiceData(this.invoiceData.id, {
          invoice_date: this.form.invoice_date || null,
          remarks: this.form.remarks,
          po_no: this.form.po_no,
          boe: this.form.boe,
        })
        .then(() => {
          this.$bus.$emit("showToastMessage", {
            message: "Invoice details updated successfully!",
            color: "success",
          });
          this.$emit("updated");
          this.close();
        })
        .catch(() => {
          this.$bus.$emit("showToastMessage", {
            message: "Failed to update invoice details.",
            color: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
